import React, { SetStateAction, Dispatch } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { TextField, Grid, Chip, Typography } from '@material-ui/core';
import { get, isNil } from 'lodash';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Document from 'components/Document';
import { COLORS } from 'constants/design';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import { arrayTranslate, translate } from 'containers/services/translate';
import { StyledGrid } from 'containers/ExpertExpertise/FillExpertise/style';
import messages from 'containers/ExpertExpertise/FillExpertise/messages';
import {
  DOCUMENT,
  MISSION_EXPERISE_VICTIM_STATUS,
  VEHICULE_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import CustomSelect from 'containers/ExpertExpertise/FillExpertise/CustomSelect';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { displayErrorText } from 'containers/services/validateForm';
import { handleOpenDocument } from 'services/utils';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { DOCUMENT_TYPES } from 'constants/global';
import { VictimType } from 'typings/globalTypes';

export interface MechanicalExpertiseProps {
  intl: IntlShape;
  title: any;
  setFormBody: Function;
  formBody: any;
  victim: VictimType;
  vehicle: any;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  setDocumentId: Function;
  uploadedDocument: IUploadedDocument;
  documentId: string;
  documentIdStore: string;
  document: JudgementOnMeritsDoc;
  setDocument: Dispatch<SetStateAction<JudgementOnMeritsDoc>>;
  validateExpertise: any;
  validateDocumentExpertise: any;
  isReadOnly?: boolean;
  listings: any;
  sagis_code: any;
  mission: any;
  requestGetDocByDocumentumId: Function;
}

export const MechanicalExpertise: React.FC<MechanicalExpertiseProps> = ({
  title,
  vehicle,
  setFormBody,
  formBody,
  ...props
}): JSX.Element => {
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);

  const handleChange = (fieldName: string) => (
    e: React.ChangeEvent<{ value: unknown; name?: string }>,
  ) => {
    const { value } = e.target;
    setFormBody({ ...formBody, [fieldName as string]: value });
  };

  const handleChangeText = (fieldName: string) => (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    setFormBody({ ...formBody, [fieldName]: event.target.value });
  };
  const documentError = displayErrorText(
    props.validateDocumentExpertise,
    translateArrayErrorMessages(props.validateDocumentExpertise, true),
  );

  const deleteDoc = () => {
    if (!get(props.document, 'response', null)) {
      props.setDocument({ ...props.document, response: '', url: '' } as any);
    } else {
      props.setDocument({ ...props.document, url: '', response: '' } as any);
    }
  };

  const setDoc = (document: CorporealDocument) => {
    if (!document.name && !document.type) {
      props.setDocument({
        ...document,
        url: document.url,
        response: document.url,
      } as any);

      props.resetUploadDocumentStore();
    } else if (props.documentId === props.documentIdStore) {
      props.setDocument({
        ...document,
        name: document.name,
        type: document.type,
        url: document.url,
        response: document.url,
      } as any);
      props.resetUploadDocumentStore();
    }
  };
  const assignement = get(props.mission, 'assignedExperts').find(
    (element: any) => element.expertCode === props.sagis_code,
  );
  return (
    <CustomAccordion
      title={title}
      textColor={COLORS.ACCORDION_TEXT_BLUE}
      bgColor={COLORS.ACCORDION_BG_BLUE}
      image={expertiseExpertiseIcon}
    >
      <StyledGrid container spacing={3} alignItems="center">
        <Grid item xs={4}>
          <CustomSelect
            title={translate(messages.vehicleTitle, props)}
            items={[
              { label: `${get(vehicle, 'registrationNumber', '')}`, value: 1 },
            ]}
            value={1}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label={translate(messages.damageAmount, props)}
            name={VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT}
            value={get(formBody, VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT, '')}
            type="number"
            fullWidth
            onChange={handleChange(VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT)}
            InputProps={{ disabled: props.isReadOnly }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            title={
              assignement?.type ===
                MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION &&
              get(formBody, 'createdBy', '') === props.sagis_code
                ? translate(messages.commentAppreciation, props)
                : translate(messages.comment, props)
            }
            label={
              assignement?.type ===
                MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION &&
              get(formBody, 'createdBy', '') === props.sagis_code
                ? translate(messages.commentAppreciation, props)
                : translate(messages.comment, props)
            }
            value={formBody.comment}
            onChange={handleChangeText('comment')}
            fullWidth
            InputProps={{
              disabled: props.isReadOnly,
            }}
          />
        </Grid>
        {get(formBody, 'status') ===
        MISSION_EXPERISE_VICTIM_STATUS.VALIDATED ? (
          <Grid item xs={12}>
            <section>
              {props.uploadedDocument && (
                <div className="support-document-info">
                  <Document
                    name={get(props.uploadedDocument, 'name', '')}
                    type={get(props.uploadedDocument, 'type', '')}
                    icon={
                      <VisibilityIcon
                        className="consult"
                        onClick={handleOpenDocument(
                          props.uploadedDocument as any,
                          props.requestGetDocByDocumentumId,
                        )}
                      />
                    }
                  />
                </div>
              )}
            </section>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Grid item xs={12}>
              <UploadDocumentBloc
                index={0}
                document={props.document}
                resetUploadedDocument={props.resetUploadDocumentStore}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                docType={DOCUMENT_TYPES.RAPPORT_CONSEIL}
                setDocumentId={props.setDocumentId}
                docId={props.documentId}
                setDocument={setDoc}
                deleteDoc={
                  !isNil(get(formBody, 'id')) &&
                  (get(formBody, 'status') ===
                    MISSION_EXPERISE_VICTIM_STATUS.PENDING ||
                    get(formBody, 'status') ===
                      MISSION_EXPERISE_VICTIM_STATUS.VALIDATED)
                    ? undefined
                    : props.sagis_code === get(formBody, 'createdBy')
                    ? deleteDoc
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={12}>
              <div className="error">
                {documentError?.message[DOCUMENT.NAME]}
              </div>
            </Grid>
          </Grid>
        )}
        {((props.isReadOnly && get(formBody, 'status')) ||
          get(formBody, 'status') ===
            MISSION_EXPERISE_VICTIM_STATUS.REJECTED) && (
          <>
            <Grid item>
              <Typography
                style={{
                  color: COLORS.LIGHT_GREY,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {translate(messages.statusTitle, props)}
              </Typography>
            </Grid>
            <Grid item xs={11}>
              <Chip
                style={{
                  backgroundColor: renderColor(get(formBody, 'status')),
                  color: COLORS.WHITE,
                  fontWeight: 700,
                }}
                label={renderChipLabel(get(formBody, 'status'))}
              />
            </Grid>
          </>
        )}
        {(props.isReadOnly &&
          get(formBody, 'status') &&
          get(formBody, 'createdBy')) ||
        get(formBody, 'status') === MISSION_EXPERISE_VICTIM_STATUS.REJECTED ? (
          <>
            <Grid item>
              <Typography
                style={{
                  color: COLORS.LIGHT_GREY,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {translate(messages.createdByTitle, props)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  color: COLORS.TEXT_BLACK,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {getValueByCode(
                  get(formBody, 'createdBy') as string,
                  get(props.listings, 'intervenants'),
                )}
              </Typography>
            </Grid>
          </>
        ) : (
          <></>
        )}
        {get(formBody, 'decisionComment') && (
          <>
            <Grid item>
              <Typography
                style={{
                  color: COLORS.LIGHT_GREY,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {translate(messages.comment, props) + ':'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: COLORS.TEXT_BLACK,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {get(formBody, 'decisionComment')}
              </Typography>
            </Grid>
          </>
        )}
        {get(formBody, 'rejectionReason') &&
          get(formBody, 'status') ===
            MISSION_EXPERISE_VICTIM_STATUS.REJECTED && (
            <>
              <Grid item>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.reason, props) + ':'}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{
                    color: COLORS.TEXT_BLACK,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {get(formBody, 'rejectionReason')}
                </Typography>
              </Grid>
            </>
          )}
      </StyledGrid>
    </CustomAccordion>
  );
};

export default injectIntl(MechanicalExpertise);
